const ASSET_TYPE = {
  CAPTION: "caption",
  VIDEO: "video",
  IMAGE: "image",
  OTHER: "other",
};

export default ASSET_TYPE;
